/** @format */

import { gql } from '@apollo/client';
import { Customer } from '../types/customer';
import { updatePolicy } from '../../policies/services/updatePolicies';

export const GET_POLICY_BY_ID = gql`
  query GetPolicyById($getPolicyByIdId: String!) {
    getPolicyById(id: $getPolicyByIdId) {
      _id
      leadId
      request
      firstName
      lastName
      email
      occupation
      phoneNumber
      ssn
      bestPhoneNumber
      FFMId
      memberId
      dob
      planType
      householdIncome
      QLE
      healthSherpa
      NPN
      AOR
      enrollmentFee
      userId
      officeId
      agentName
      vendorName
      benefitsURL
      notes
      createdAt
      updatedAt
      majorMed {
        _id
        carrier
        isPostDate
        billingDate
        premium
        status
      
      }
      office {
        officeName
      }
      address {
        _id
        street
        city
        state
        aptUnite
        zipCode
        country
      }
      user {
        firstName
        lastName
      }
      privateMed {
        _id
        carrier
        isPostDate
        billingDate
        premium
        status
     
      }
      spouseInfo {
        _id
        firstName
        lastName
        dob
        ssn
      }
      ancillaries {
        _id
        carrier
        isPostDate
        billingDate
        premium
        status
     
      }
      dependentsInfo {
        _id
        firstName
        lastName
        dob
        ssn
      }
    }
  }
`;

export interface GetPolicyByIdResponse {
  getPolicyById: Customer;
}

/**
 * Update customer/policy using REST API
 */
export const updateCustomer = async (
  customerId: string,
  updateData: Partial<Customer>
): Promise<any> => {
  return await updatePolicy(customerId, updateData);
};
